import {createIcon, Svg} from "@gluestack-ui/icon";
import {Circle} from "react-native-svg";

const EllipseIcon = createIcon({
  Root: Svg,
  viewBox:"0 0 14 14",
  path: (
    <>
      <Circle cx="7" cy="7" r="6" fill="#EAECF0" stroke="#98A2B3" stroke-width="2"/>
    </>
  ),
});

EllipseIcon.displayName = "EllipseIcon";
export {EllipseIcon};
